export default __webpack_public_path__ + "static/profiles-baaad187170169cec5c07c7c06db0625.png";